import { render, staticRenderFns } from "./JobComponent.vue?vue&type=template&id=5b146f86&scoped=true"
import script from "./JobComponent.vue?vue&type=script&lang=ts"
export * from "./JobComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b146f86",
  null
  
)

export default component.exports